import React from 'react';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Card } from 'react-bootstrap';
// import { Link } from 'react-router-dom';
// import { faHome } from '@fortawesome/free-solid-svg-icons';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PageHeader from 'components/common/PageHeader';
import {Link} from 'react-router-dom'

const FaseC = () => {

  return (<>
    <PageHeader
    title="Fase C EFRAG"
    description="VALUTAZIONE RILEVANZA RISCHI DI IMPATTO/FINANZIARI E MITIGAZIONE RISCHI CON AZIONI/OPPORTUNITÀ"
    className="mb-3"
    >
    </PageHeader>
    
    <Card key="CRITERI"  style={{marginTop:"2%", marginBottom:"2%"}}>
        <Card.Body>
          <Card.Title>
            <h5 className="text-info fw-medium mb-0" style={{marginBottom:"3%"}}>Criteri</h5>
          </Card.Title>
          <Card.Text>
          <ul style={{listStyleType:"none"}}>
            <li key="ALL10">
          <Link to="scheda-10">
            SCHEDA 10 – CRITERI VALUTAZIONE RILEVANZA RISCHI DI IMPATTO E FINANZIARI 
            <FontAwesomeIcon icon="chevron-right" className="ms-1 fs-11" />
          </Link> 
          </li>

          <li key="ALL11">
          <Link to="scheda-11">
            SCHEDA 11 – CRITERI VALUTAZIONE MITIGAZIONI RISCHI CON AZIONI PERSEGUIMENTO OPPORTUNITÀ IMPATTI/FINANZIARIE
            <FontAwesomeIcon icon="chevron-right" className="ms-1 fs-11" />
          </Link> 
          </li>

          </ul>
          </Card.Text>
        </Card.Body>
      </Card>

      <Card key="SCHEMI"  style={{marginTop:"2%", marginBottom:"2%"}}>
        <Card.Body>
          <Card.Title>
          <h5 className="text-primary mb-0" style={{marginBottom:"3%"}}><span className="text-info fw-medium">Schemi</span></h5>
          </Card.Title>
          <Card.Text>
          <ul style={{listStyleType:"none"}}>
            <li key="ALL12">
          <Link to="scheda-12">
            SCHEDA 12 - SCHEMA UNIFICATO RILEVAZIONE INPUT PARTE VALUTAZIONE RISCHI E MITIGAZIONI  
            <FontAwesomeIcon icon="chevron-right" className="ms-1 fs-11" />
          </Link> 
          </li>
          </ul>
          </Card.Text>
        </Card.Body>
      </Card>

    </>)
};

export default FaseC;
